/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Gpindicativeorder3Inputs */

const en_coinvestments_tracking_gpindicativeorder3 = /** @type {(inputs: Coinvestments_Tracking_Gpindicativeorder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicative Order`)
};

/**
* | output |
* | --- |
* | "Indicative Order" |
*
* @param {Coinvestments_Tracking_Gpindicativeorder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_gpindicativeorder3 = /** @type {((inputs?: Coinvestments_Tracking_Gpindicativeorder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Gpindicativeorder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_gpindicativeorder3(inputs)
});
export { coinvestments_tracking_gpindicativeorder3 as "coInvestments_tracking_gpIndicativeOrder" }